import type { CategoryId } from "@/services/collection/categories/categoriesSchema";
import { type Category } from "@/services/collection/categories";
import { type CategoryIdOrAll } from "@/services/collection/categories/categoriesSelect";
import type { Collectible } from "@/services/collectibles";

export type ArticlesGetOptions = {
  perPage?: number;
  offset?: number;
  categoryId?: CategoryIdOrAll;
};

export enum ArticleComponentType {
  Paragraph = "Paragraph",
  H2 = "H2",
  H3 = "H3",
  H4 = "H4",
  Survey = "Survey",
  Button = "Button",
  Video = "Video",
  Image = "Image",
  Banner = "CollectionBanner",
}

type ArticleComponent = {
  name: ArticleComponentType;
  content1: string;
  content2: string;
  content3: string;
};

export type ArticleImage = {
  file: {
    main: string;
    thumb: string;
  };
};

export type ArticleId = number;

export type Article = {
  id: ArticleId;
  name: string;
  perex: string;
  url: string;
  author?: {
    name: string;
  };
  category: {
    id: CategoryId;
  };
  datePublish: string;
  readLength: number;
  images: ArticleImage[];
  components?: ArticleComponent[];
};

export enum ArticleWidgetType {
  DatabaseItem = "databaseItem",
}

export type ArticleWidget = {
  type: ArticleWidgetType;
  triggerElementIdentification: string;
  params: {
    category: Category;
    item: Collectible;
    label: string;
    price: string;
    date: string;
  };
};
